import { NotificationsService } from '@pf/shared-ui';
import { inject } from '@angular/core';
import { NotificationType, ToastMessage, ToastType } from '@pf/shared-common';
import { RequestFailureHandler } from '@pf/shared/ui-platform';
import { HttpErrorResponse, HttpRequest } from '@angular/common/http';

const ignoredUrls = ['load-workflows/execute'];

export const requestFailureHandler: RequestFailureHandler = (
    request: HttpRequest<unknown>,
    errorMessage: string,
    _: HttpErrorResponse
) => {
    if (ignoredUrls.some(url => request.url.includes(url))) {
        return;
    }
    inject(NotificationsService).create({
        type: NotificationType.ToastMessage,
        toastType: ToastType.error,
        message: 'Request failed! ' + errorMessage,
    } as ToastMessage);
};
